import { DEFAULT_TIMEZONE } from '../constant/timezones';

let currentUser = {};

export const setCurrentUser = (user) => {
    currentUser = user || {};
};

export const getCurrentUser = () => currentUser;

export const getUserTimezone = () => currentUser?.timezone || DEFAULT_TIMEZONE;
